import { apiClient } from './apiClient'
import type {
  SwitchList,
  SwitchListPreviewRequest,
  WorkOrderDispatchRequest,
  WorkOrderDispatchResponse,
} from '../types/interchange'

export function calculateSwitchInstructions(
  payload: SwitchListPreviewRequest
): Promise<SwitchList> {
  return apiClient.post<SwitchList>('/api/v1/workorders/calculate-switch-instructions', payload)
}

export function dispatchWorkOrder(
  payload: WorkOrderDispatchRequest
): Promise<WorkOrderDispatchResponse> {
  return apiClient.post<WorkOrderDispatchResponse>('/api/v1/workorders/dispatch', payload)
}

export function recomputeSwitchList(workOrderId: string): Promise<SwitchList> {
  return apiClient.post<SwitchList>(`/api/v1/switchlists/${workOrderId}/recompute`, {})
}

export function updateWorkOrderStatus(
  workOrderId: string,
  status: string
): Promise<WorkOrderDispatchResponse> {
  return apiClient.patch<WorkOrderDispatchResponse>(`/api/v1/workorders/${workOrderId}/status`, { status })
}
